// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';

// INNER IMPORTS
import './MediaAndLinks.css';
import ImagesUpload from './ImagesUpload';

const MediaAndLinks = props => {
    //  Selling tickets online?
    // insert your tickets web page url
    const renderTicketLink = () => {
        return([
            <div key={0} className={"title " + props.type}>
               מוכרים כרטיסים אונליין?
            </div>,
            <div key={1} className="ticket-links-wrapper">
                <input
                    type="text"
                    name="ticketLink"
                    placeholder="הזינו לינק לרכישת כרטיסים"
                    onChange={props.updateValue} value={props.ticketLink}
                />
            </div>
        ])
    };

   // Media & Links
    // Please insert a Youtube/Vimeo video url here
    // Any link you want
    return (
        <div className={`mediaAndLinks rtl ${props.type}`}>
            {props.type === 'liveMusic' ? renderTicketLink() : null}
            <div className={"title " + props.type}>
                מדיה וקישורים
            </div>
            <div className={"leftPart " + props.type}>
                <input type="text" name="video" placeholder="הזינו לינק לוידאו ב- Youtube/Vimeo"
                       onChange={props.updateValue} value={props.video}
                />

                <input
                    type="text"
                    name="link1"
                    placeholder="כל לינק אחר"
                    onChange={props.updateValue} value={props.link1}
                />
                {/*<input*/}
                    {/*type="text"*/}
                   {/*name="link2"*/}
                   {/*placeholder="link 2"*/}
                   {/*onChange={props.updateValue}*/}
                   {/*value={props.link2}*/}
                {/*/>*/}
            </div>
            <div className="rightPart">
                <ImagesUpload
                    onDrop={props.onDrop}
                    removeImage={props.removeImage}
                    files={props.files}
                    uploadSuccess={props.uploadSuccess}
                    uploadedImages={props.uploadedImages}
                    selectMainImage={props.selectMainImage}
                />
            </div>
        </div>
    )
};

MediaAndLinks.propTypes = {
    type: PropTypes.string,
    updateValue: PropTypes.func,
    video: PropTypes.string,
    ticketLink: PropTypes.string,
    link1: PropTypes.string,
    onDrop: PropTypes.func,
    removeImage: PropTypes.func,
    files: PropTypes.array,
    uploadedImages: PropTypes.array,
    uploadSuccess: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    selectMainImage: PropTypes.func
};

export default MediaAndLinks;



// WEBPACK FOOTER //
// ./src/Components/Users/Submit/MediaAndLinks.js